var map = {
	"./account-history.svg": "b3d8",
	"./account-overview.svg": "8fa1",
	"./add.svg": "76a4",
	"./archived-orders.svg": "e233",
	"./arrow-left.svg": "ac3b",
	"./arrow-right.svg": "cd8c",
	"./balance-increased.svg": "6b17",
	"./basket.svg": "382e",
	"./bch.svg": "90ab",
	"./bill-is-paid.svg": "b49a",
	"./bonus-program.svg": "8174",
	"./btc.svg": "15a0",
	"./calendar.svg": "b8bd",
	"./card.svg": "5d4a",
	"./chat.svg": "9b69",
	"./chf.svg": "9f22",
	"./clip.svg": "9d0f",
	"./clock.svg": "755b",
	"./close.svg": "8b1b",
	"./cloud.svg": "2b35",
	"./copy.svg": "8aac",
	"./countries/be.svg": "9657",
	"./countries/br.svg": "1128",
	"./countries/ch.svg": "aef9",
	"./countries/de.svg": "8452",
	"./countries/fi.svg": "581b",
	"./countries/ie.svg": "2c1f",
	"./countries/in.svg": "7076",
	"./countries/tw.svg": "5663",
	"./countries/ua.svg": "004c",
	"./countries/us.svg": "683c",
	"./countries/vn.svg": "e819",
	"./currency-calculator.svg": "d3a9",
	"./danger-circle.svg": "c20d",
	"./deposit-replenished.svg": "b3d5",
	"./dislike.svg": "a2a2",
	"./document.svg": "4aa0",
	"./done.svg": "e404",
	"./down.svg": "d8aa",
	"./download-file.svg": "4c74",
	"./download.svg": "f28e",
	"./dsh.svg": "841d",
	"./edit.svg": "daf0",
	"./email.svg": "43be",
	"./eth.svg": "a25f",
	"./eur.svg": "4ba1",
	"./exit.svg": "a2ab",
	"./file.svg": "a147",
	"./filters.svg": "1d60",
	"./gear.svg": "f571",
	"./info-big.svg": "3ffa",
	"./info.svg": "76ed",
	"./invoice-canceled.svg": "c69f",
	"./invoice-created.svg": "9faf",
	"./invoice.svg": "c7d2",
	"./like.svg": "6d8b",
	"./linux.svg": "cc69",
	"./loader.svg": "04ff",
	"./loading.svg": "1e31",
	"./lock.svg": "9619",
	"./ltc.svg": "0067",
	"./menu.svg": "d17f",
	"./minus.svg": "3e24",
	"./monitor.svg": "2477",
	"./moon.svg": "0190",
	"./move.svg": "d8c1",
	"./new-order-created.svg": "88fe",
	"./next.svg": "0043",
	"./nxt.svg": "e0de",
	"./off.svg": "d12f",
	"./on.svg": "e2bf",
	"./option-off.svg": "7e1e",
	"./option-on.svg": "911f",
	"./order-groups.svg": "956a",
	"./partner.svg": "32ba",
	"./pd.svg": "cd5c",
	"./plus.svg": "eb38",
	"./power.svg": "111a",
	"./prev.svg": "ed83",
	"./print.svg": "671e",
	"./product-hot.svg": "5545",
	"./product-new.svg": "7d4a",
	"./rate-us.svg": "ca844",
	"./renewal-of-order.svg": "9de4",
	"./resale.svg": "9876",
	"./rub.svg": "8e13",
	"./sale.svg": "681b",
	"./security.svg": "5f0d",
	"./send.svg": "5b6e",
	"./server.svg": "90f6",
	"./shield-filled.svg": "e477",
	"./shield-hollow.svg": "abec",
	"./shutdown.svg": "0c34",
	"./sort-down.svg": "f76e",
	"./sort-up.svg": "f797",
	"./star-filled.svg": "3d1d",
	"./star-hollow.svg": "73b1",
	"./subtract.svg": "86d0",
	"./success-circle.svg": "3b91",
	"./sun.svg": "3961",
	"./support.svg": "33f5",
	"./tag.svg": "81fd",
	"./trash.svg": "af22",
	"./usd.svg": "f04f",
	"./usdt.svg": "b1d1",
	"./volume-off.svg": "3ec0",
	"./volume-on.svg": "4ad6",
	"./windows.svg": "8b1e",
	"./xrp.svg": "7358"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "6f32";